import { render, staticRenderFns } from "./PortalsSecondaryList.vue?vue&type=template&id=30ce04ab&"
import script from "./PortalsSecondaryList.vue?vue&type=script&lang=js&"
export * from "./PortalsSecondaryList.vue?vue&type=script&lang=js&"
import style0 from "./PortalsSecondaryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports